import { useSelector } from 'react-redux';
import { isIOS, isFlutterApp } from '@ecs-uk/web-common-mobile-view-helpers';
import useExistingPaymentMethod from '../components/PaymentCaptureMethod/hooks/useExistingPaymentMethod';
import useSplits from './useSplits';
import { splitsList } from '../constants';
import { PaymentMethodTypes } from '../components/PaymentCaptureMethod/constants.ts';

const usePaymentMethodSupported = () => {
  const { existingPaymentType } = useExistingPaymentMethod();
  const splitReady = useSelector(state => state.split?.fetched);

  const splits = useSplits([
    splitsList.applePayWebRollout,
    splitsList.disableApplePayRecurly,
    splitsList.googlePayWebRollout,
    splitsList.disableGooglePayRecurly,
    splitsList.disableGooglePayOnAndroid,
  ]);

  const disableApplePay = splits[splitsList.disableApplePayRecurly];
  const disableGooglePay = splits[splitsList.disableGooglePayRecurly];
  const disableGooglePayOnAndroid = splits[splitsList.disableGooglePayOnAndroid];
  const googlePayUpsellTest = splits[splitsList.googlePayWebRollout];
  const applePayUpsellTest = splits[splitsList.applePayWebRollout];

  const applePaySupported = typeof window !== 'undefined' && !!window?.ApplePaySession?.canMakePayments?.();
  const isIOSFlutterApp = isIOS() && isFlutterApp();
  const isAndroidFlutterApp = !isIOS() && isFlutterApp();

  if (!splitReady && existingPaymentType !== PaymentMethodTypes.Card) {
    return false;
  }

  switch (existingPaymentType) {
    case PaymentMethodTypes.ApplePay:
      return applePayUpsellTest && applePaySupported && !disableApplePay;

    case PaymentMethodTypes.GooglePay: {
      const isGooglePayDisabledForPlatform = isIOSFlutterApp || (isAndroidFlutterApp && disableGooglePayOnAndroid);
      return googlePayUpsellTest && !disableGooglePay && !isGooglePayDisabledForPlatform;
    }

    case PaymentMethodTypes.Card:
      return true;

    default:
      return false;
  }
};

export default usePaymentMethodSupported;
